import { apiPost, apiGet } from '@/lib/api-client';
import type {
  ValidateApiKeyRequest,
  ValidateApiKeyResponse,
  RemoveApiKeyRequest,
  RemoveApiKeyResponse,
  GetStoreInfoResponse,
} from '@shared/types/dashboard';

export const validateApiKey = async (request: ValidateApiKeyRequest): Promise<ValidateApiKeyResponse> => {
  const response = await apiPost<ValidateApiKeyResponse>('/api/api-key/validate', request);
  return response.data || response as ValidateApiKeyResponse;
};

export const removeApiKey = async (request: RemoveApiKeyRequest): Promise<RemoveApiKeyResponse> => {
  const response = await apiPost<RemoveApiKeyResponse>('/api/api-key/remove', request);
  return response.data || response as RemoveApiKeyResponse;
};

export const getApiKeyStatus = async (shop: string): Promise<GetStoreInfoResponse> => {
  const response = await apiGet<GetStoreInfoResponse>(`/api/api-key/status?shop=${encodeURIComponent(shop)}`);
  return response.data || response as GetStoreInfoResponse;
};

